exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-column-item-3zmOv{display:flex;align-items:center;padding-right:16px}.style-column-item-3zmOv img{width:20px;height:20px}", ""]);

// Exports
exports.locals = {
	"column-item": "style-column-item-3zmOv"
};